import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class HandleErrorService {
  constructor(
    private notify: NotificationService,
    private authService: AuthService
  ) {}

  // Handling HTTP Errors using snackBar
  public handleError(err: HttpErrorResponse): any {
    // HANDLE GLOBAL ERRORS & PROVIDE NOTIFICATION IN SNACKBAR
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client side or network error occurred
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code
      switch (err.status) {
        case 400:
          errorMessage = 'Bad Request.';
          break;
        case 401:
          errorMessage = ''; // no error message since its already handled in UI
          break;
        case 403:
          errorMessage =
            // tslint:disable-next-line:quotemark
            'You do not have permission to access the requested resource.';
          // Logout out user, & navigate to login screen as hes not authorized
          // this.authService.logout();
          break;
        case 404:
          errorMessage = 'The requested resource does not exist.';
          break;
        case 409:
          errorMessage = err.error.message;
          break;
        case 412:
          errorMessage = err.error.message;
          break;
        case 500:
          errorMessage =
            'Internal Server Error,please contact the adminstrator';
          break;
        // case 501:
        //   errorMessage = 'Login expired please login again';
        //   break;
        case 502:
          errorMessage = 'Encountered Bad Gateway';
          break;
        case 503:
          errorMessage = 'The requested service is not available.';
          break;
        default:
          errorMessage = '';
      }
    }
    if (errorMessage) {
      this.notify.openSnackBar(errorMessage, 'close', 5000);
    }
  }
}
